import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import footerLogo from '../../static/images/marketing/footer-logo.png';
import LegalNotice from './LegalNotice';

function Copyright() {
  return (
    <Typography
      variant="body2"
      sx={{
        color: 'text.secondary',
        transform: { xs: 'translateY(0)', sm: 'translateY(0)', md: 'translateY(50px)' },
      }}
    >
      {'Copyright © '}
      <Link color="text.secondary" href="#">
        REPLICO
      </Link>
      &nbsp;
      {new Date().getFullYear()}
    </Typography>
  );
}

export default function Footer() {
  const [isLogoLoaded, setIsLogoLoaded] = React.useState(false);

  return (
    <Box
      sx={{
        bgcolor: '#f5f2ef',
        pt: { xs: 4, sm: 5 },
        pb: { xs: 0, sm: 0, md: 8 },
        minHeight: { xs: 220, sm: 260, md: 250 },
        position: 'relative',
      }}
    >
      <Container
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: { xs: 'flex-start', md: 'center' },
          justifyContent: { xs: 'flex-start', md: 'flex-start' },
          gap: { xs: 3, md: 2 },
          pb: { xs: 3, sm: 4 },
        }}
      >
        <Stack
          spacing={{ xs: 2, sm: 3, md: 2 }}
          sx={{
            alignItems: { xs: 'center', md: 'flex-start' },
            textAlign: { xs: 'center', md: 'left' },
            width: { xs: '100%', md: 'auto' },
            transform: { xs: 'translateY(60px)', sm: 'translateY(0)', md: 'translateY(50px)' },
          }}
        >
          {!isLogoLoaded ? (
            <>
              <Skeleton variant="text" width={180} height={20} />
              <Skeleton variant="text" width={140} height={18} />
            </>
          ) : (
            <>
              <Link color="text.secondary" variant="body2" href="mailto:contact@replico.tech">
                contact@replico.tech
              </Link>
              <Link color="text.secondary" variant="body2" href="/legal" target="_blank" rel="noopener" sx={{ transform: { xs: 'translateY(0)', sm: 'translateY(0)', md: 'translateY(25px)' } }}>
               Legal Notice
              </Link>
                
                              
              <Copyright />
            </>
          )}
        </Stack>
      </Container>
      <Box
        component="img"
        src={footerLogo}
        alt="Replico logo"
        loading="lazy"
        onLoad={() => setIsLogoLoaded(true)}
        sx={{
          width: { xs: '85%', sm: '70%', md: 250 },
          maxWidth: { xs: 220, sm: 260, md: 250 },
          height: 'auto',
          position: { xs: 'static', sm: 'static', md: 'absolute' },
          left: { xs: 'auto', sm: 'auto', md: '50%' },
          right: { xs: 'auto', sm: 'auto', md: 'auto' },
          bottom: { xs: 'auto', sm: 'auto', md: 0 },
          transform: { xs: 'none', sm: 'none', md: 'translateX(-50%)' },
          display: 'block',
          mx: { xs: 'auto', sm: 'auto', md: 0 },
          mt: { xs: 6, sm: 4, md: 0 },
          opacity: isLogoLoaded ? 1 : 0,
          transition: 'opacity 200ms ease',
        }}
      />
      {!isLogoLoaded && (
        <Skeleton
          variant="rectangular"
          sx={{
            width: { xs: '85%', sm: '70%', md: 250 },
            maxWidth: { xs: 220, sm: 260, md: 250 },
            height: { xs: 90, sm: 110, md: 90 },
            position: { xs: 'static', sm: 'static', md: 'absolute' },
            left: { xs: 'auto', sm: 'auto', md: '50%' },
            bottom: { xs: 'auto', sm: 'auto', md: 0 },
            transform: { xs: 'none', sm: 'none', md: 'translateX(-50%)' },
            mx: { xs: 'auto', sm: 'auto', md: 0 },
            mt: { xs: 6, sm: 4, md: 0 },
          }}
        />
      )}
    </Box>
  );
}
